module.exports = __webpack_public_path__ + "img/neosurf.0e76a46c.svg";